import React, { useEffect, useReducer, useState } from 'react'
import { BingoObject } from './carBingoObjects'
import { useInRouterContext, useLocation } from 'react-router-dom'

function shuffle(array: any[]) {
    let currentIndex = array.length

    // While there remain elements to shuffle...
    while (currentIndex !== 0) {
        // Pick a remaining element...
        const randomIndex = Math.floor(Math.random() * currentIndex)
        // eslint-disable-next-line no-plusplus
        currentIndex--

        // And swap it with the current element.
        // eslint-disable-next-line no-param-reassign
        ;[array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex],
        ]
    }

    return array
}

class BingoBoardState {
    board: BingoObject[]
    bingoObjects: BingoObject[]

    private stateKey: string = 'bingoBoardState'

    constructor(bingoObjects: BingoObject[]) {
        this.bingoObjects = bingoObjects
        this.board = this.retrieveBoard()
        this.storeState()
    }

    crossCellInBoard(id: number): BingoBoardState {
        this.board = this.board.map((it) => ({
            ...it,
            crossed: it.id === id ? !it.crossed : it.crossed,
        }))
        this.storeState()
        return this
    }

    deleteBoard() {
        this.board = []
        localStorage.removeItem(this.stateKey)
    }

    private generateBoard(): BingoObject[] {
        return shuffle(this.bingoObjects).slice(0, 25)
    }

    private storeState() {
        localStorage.setItem(this.stateKey, JSON.stringify(this.board))
    }

    private retrieveBoard(): BingoObject[] {
        const json = localStorage.getItem(this.stateKey)
        if (json === 'undefined' || json === null) {
            return this.generateBoard()
        }

        return JSON.parse(json)
    }
}

// eslint-disable-next-line no-unused-vars
export function BingoEle(props: {
    bingoObject: BingoObject
    markCrossed: (id: number) => void
}) {
    const { bingoObject, markCrossed } = props
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    return (
        <div
            className={`bingo-object ${bingoObject.crossed ? 'marked' : ''}`}
            onClick={() => markCrossed(bingoObject.id)}
        >
            <p>{bingoObject.label}</p>
        </div>
    )
}

export function BingoBoard({ bingoObjects }: { bingoObjects: BingoObject[] }) {
    const [bingoBoard, setBingoBoard] = useState<BingoBoardState>()
    const [, forceUpdate] = useReducer((x) => x + 1, 0)
    const location = useLocation()

    function createBingoBoard() {
        setBingoBoard(new BingoBoardState(bingoObjects))
    }

    useEffect(() => {
        if (!bingoBoard) {
            createBingoBoard()
        }
    }, [location.pathname])

    function newBoard() {
        bingoBoard?.deleteBoard()
        setBingoBoard(new BingoBoardState(bingoObjects))
    }

    function markCrossed(id: number) {
        const state = bingoBoard?.crossCellInBoard(id)
        setBingoBoard(state)
        forceUpdate()
    }

    return (
        <div style={{ margin: 5, padding: 5 }}>
            <div
                style={{
                    display: 'flex',
                    justifyItems: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <button
                    style={{ margin: 5, padding: 5, fontSize: '1.2em' }}
                    onClick={() => newBoard()}
                >
                    Nytt bingobrett
                </button>
            </div>
            <div className="grid-container">
                {bingoBoard?.board.map((obj) => (
                    <BingoEle
                        key={obj.id}
                        markCrossed={markCrossed}
                        bingoObject={obj}
                    />
                ))}
            </div>
        </div>
    )
}
